import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { InfoDialogComponent } from '../components/info-dialog/info-dialog.component';

type ColorChoices = 'primary' | 'accent' | 'warn' | 'basic' | 'disabled';
type Func = () => void;

interface StyleSelection {
  color: ColorChoices;
  stroked?: boolean;
}

export interface InfoDialogConfig {
  width: string;
  title: string;
  message: string;
  button1?: {
    text: string;
    action?: Func;
    style: StyleSelection;
  };
  button2?: {
    text: string;
    action?: Func;
    style: StyleSelection;
  };
  timeout?: number;
}

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialog = inject(MatDialog);


  openDialog(config: InfoDialogConfig): void {
    if (config.timeout && (config.button1 || config.button2)) {
      throw new Error('Cannot have both timeout and buttons.');
    }
    if (config.button1 && config.button1.style && config.button1.style.stroked === undefined) {
      config.button1.style.stroked = false;
    }
    if (config.button2 && config.button2.style && config.button2.style.stroked === undefined) {
      config.button2.style.stroked = false;
    }
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      width: config.width || '250px',
      data: config,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'button1' && config.button1 && config.button1.action) {
        config.button1.action();
      } else if (result === 'button2' && config.button2 && config.button2.action) {
        config.button2.action();
      }
    });
  }
}
